import { render, staticRenderFns } from "./RaceDetail.vue?vue&type=template&id=23d6b9de"
import script from "./RaceDetail.vue?vue&type=script&lang=js"
export * from "./RaceDetail.vue?vue&type=script&lang=js"
import style0 from "./RaceDetail.vue?vue&type=style&index=0&id=23d6b9de&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports